import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getProjects } from "@/lib/time-api";
import { useOrgId } from "@/lib/org-context";

export function useProjects(includeArchived = false) {
  const queryClient = useQueryClient();
  const orgId = useOrgId();

  const { data, isLoading } = useQuery({
    queryKey: ["projects", orgId, includeArchived],
    queryFn: () => getProjects({ includeArchived }),
    enabled: !!orgId,
  });

  async function refetch() {
    await queryClient.invalidateQueries({ queryKey: ["projects"] });
  }

  return {
    projects: data?.data ?? [],
    pagination: data?.pagination,
    loading: isLoading,
    refetch,
  };
}
